<template>
<div>
  <section id="feature" class="padding-top-bottom-120 bg-image-fit-50" style="background:url(images/3a.png)">
      <div class="container">
        <div class="row">
          <div class="col-md-6 feature">
            <div class="feature-wiget">
              <div class="icon-wraper">
                <i class="ion-earth"></i>
              </div>
              <div class="content">
                <h4 class="bottom-line">{{serviceData.part_four_title}}</h4>
                <p v-html="serviceData.part_four_content"></p>
                <h6>{{serviceData.part_four_title1}}</h6>
                <p v-html="serviceData.part_four_content1"></p>
              </div>
            </div>
            <div class="feature-wiget">
              <div class="icon-wraper">
                <i class="ion-link"></i>
              </div>
              <div class="content">
                <h4 class="bottom-line">{{serviceData.part_five_title}}</h4>
                <p v-html="serviceData.part_five_content"></p>
                <h6>{{serviceData.part_five_title1}}</h6>
                <p v-html="serviceData.part_five_content1"></p>
              </div>
            </div>
            <div class="feature-wiget">
              <div class="icon-wraper">
                <i class="ion-calendar"></i>
              </div>
              <div class="content">
                <h4 class="bottom-line">{{serviceData.part_one_title}}</h4>
                <h6>{{serviceData.part_one_title1}}</h6>
                <p v-html="serviceData.part_one_content1"></p>
                <h6>{{serviceData.part_one_title2}}</h6>
                <p v-html="serviceData.part_one_content2"></p>
                <h6>{{serviceData.part_one_title3}}</h6>
                <p>{{serviceData.part_one_content3}}</p>
              </div>
            </div>
            <div class="feature-wiget">
              <div class="icon-wraper">
                <i class="ion-settings"></i>
              </div>
              <div class="content">
                <h4 class="bottom-line">{{serviceData.part_two_title}}</h4>
                <p v-html="serviceData.part_two_content"></p>
                <h6>{{serviceData.part_two_title1}}</h6>
                <p v-html="serviceData.part_two_content1"></p>
              </div>
            </div>
            <div class="feature-wiget">
              <div class="icon-wraper">
                <i class="ion-ipad"></i>
              </div>
              <div class="content">
                <h4 class="bottom-line">{{serviceData.part_three_title}}</h4>
                <p v-html="serviceData.part_three_content"></p>
                <h6>{{serviceData.part_three_title1}}</h6>
                <p v-html="serviceData.part_three_content1"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="services" class="padding-top-90">
        <div class="heading-wraper text-center">
            <h4 class="">{{productData.title}}</h4>
            <hr class="heading-devider gradient-orange">
        </div>
      <div class="container">
        <div class="row">
          <div class="grid">
			<figure class="effect-ming">
				<img src="images/k1.png" alt="img09"/>
				<figcaption>
					<h4></h4>
					<p>{{productData['cw'].describe}}</p>
					<a data-toggle="modal" data-target="#myModal" @click="showModal('cw')"></a>
				</figcaption>
                <h4>{{productData['cw'].title}}</h4>		
			</figure>
			<figure class="effect-ming">
				<img src="images/k2.png" alt="img08"/>
				<figcaption>
					<h4></h4>
					<p>{{productData['sb'].describe}}</p>
					<a data-toggle="modal" data-target="#myModal" @click="showModal('sb')"></a>
				</figcaption>	
                <h4>{{productData['sb'].title}}</h4>		
			</figure>
            <figure class="effect-ming">
				<img src="images/k3.png" alt="img08"/>
				<figcaption>
					<h4></h4>
					<p>{{productData['sj'].describe}}</p>
					<a  data-toggle="modal" data-target="#myModal" @click="showModal('sj')"></a>
				</figcaption>		
                <h4>{{productData['sj'].title}}</h4>	
			</figure>
            <figure class="effect-ming">
				<img src="images/k4.png" alt="img09"/>
				<figcaption>
					<h4></h4>
					<p>{{productData['wx'].describe}}</p>
					<a  data-toggle="modal" data-target="#myModal" @click="showModal('wx')"></a>
				</figcaption>	
                <h4>{{productData['wx'].title}}</h4>			
			</figure>
			<figure class="effect-ming">
				<img src="images/k7.png" alt="img08"/>
				<figcaption>
					<h4></h4>
					<p>{{productData['dt'].describe}}</p>
					<a data-toggle="modal" data-target="#myModal" @click="showModal('dt')"></a>
				</figcaption>	
                <h4>{{productData['dt'].title}}</h4>			
			</figure>
            <figure class="effect-ming">
				<img src="images/k6.png" alt="img08"/>
				<figcaption>
					<h4></h4>
					<p>{{productData['yj'].describe}}</p>
					<a data-toggle="modal" data-target="#myModal" @click="showModal('yj')"></a>
				</figcaption>		
                <h4>{{productData['yj'].title}}</h4>		
			</figure>
		</div>
        </div>
      </div>
    </section>
    <productModal :productContent="productData[pdata_index]"></productModal>
    
    </div>
</template>
<script>
import productModal from '@/components/productModal'
import Vue from 'vue'
export default {
  name: 'product',
  props:['serviceData','productData'],
  components:{
      productModal
  },
  data () {
      return {
          pdata_index:'cw'
      }
  },
  methods:{
      showModal:function(index){
        let vm = this;
          this.pdata_index = index;
          var h = document.documentElement.clientHeight;
          $('#myModal .modal-body').css('max-height',h*0.7);
          // setTimeout(() => this.loadimg(), 5000)
          setTimeout(vm.loadimg,500);
      },
      loadimg:function(){
        var arr = $('#myModal img')
           arr.each(function(img){
              var im =$('#myModal img')[img];
              var w = im.naturalWidth;
              var h = im.naturalHeight;
            if(h>w){
                $(im).css({'max-width':'80%','margin':'auto'})
            }
           });
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/product.vue